import { Button, Row } from '../../../commonComponents';
import { InfoSection } from './components/InfoSection';
import { IEditableFormProps } from './Types';
import { Colors } from '../../../themes/colors';
import { JobDescriptionForm, JobDescriptionPreview } from './components/JobDescription';

export const JobDescriptionEditable = ({
  jobPosting,
  editMode,
  hideEditButton,
  disableSave,
  control,
  errors,
  onEditClick,
  onCancelClick,
  onSaveClick,
}: IEditableFormProps) => {
  const { description } = jobPosting || {};

  if (editMode) {
    return (
      <InfoSection
        icon="document-solid"
        title="Job Description"
        required
        rightAction={
          <Row gap={10}>
            <Button
              text="Cancel"
              onClick={onCancelClick}
              style={{ width: 90, height: 30, backgroundColor: Colors.secondary_500 }}
              textStyle={{ fontSize: 16 }}
            />
            <Button
              disabled={disableSave}
              text="Save"
              onClick={onSaveClick}
              style={{ width: 90, height: 30 }}
              textStyle={{ fontSize: 16 }}
            />
          </Row>
        }
      >
        <JobDescriptionForm control={control} errors={errors} />
      </InfoSection>
    );
  }

  return (
    <InfoSection
      icon="document-solid"
      title="Job Description"
      rightActionIcon="edit-pencil"
      onRightActionPress={hideEditButton ? undefined : onEditClick}
    >
      <JobDescriptionPreview description={description || ''} />
    </InfoSection>
  );
};
